<script>
  import PartialCircleElementTorte from "./PartialCircleElementTorte.svelte";
  import NewLeadsBalkenElement from "./NewLeadsBalkenElement.svelte";
  import { dict_to_sum, max_of_dict } from "./UtilsBalkenProgress.svelte";

  import { find_help_text_if_exists } from "./Utils.svelte";

  export let helptexts;
  export let in_show_helptext_id;

  export let table_data_dict;
  export let table_date_basis;
  export let marketing_end_date;
  export let marketing_start_date;
  export let adressable_market_size_charts_dict;

  export let lead_or_boli;

  export let laender_dict;

  export let months = ["01/22", "02/22", "03/22", "04/22", "05/22", "06/22", "07/22", "08/22", "09/22", "10/22", "11/22", "12/22"];

  function month_format(month) {
    var split = month.split("-");
    return split[1] + "/" + split[0].substring(2, 4);
  }

  function get_vorgaenger(dict, index, basis) {
    if (index == 0) {
      return basis;
    }

    var a = basis;

    for (var i = 0; i < index; i = i + 1) {
      a += dict[months[i]];
    }

    return a;
  }

  function get_width_percentage(months) {
    if (months.length < 12) {
      return 80 / 14;
    }

    return 80 / (months.length + 2);
  }
</script>

<div class="card h-100 green-border" style="width: {months.length > 12 ? 150 : 100}%;">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5 class="card-title">Market progress report</h5>
    <div class="info-circle my-auto" style="margin-left: auto;">
      <div class="my-auto info-i">i</div>
      <div class="info-box" style="color: #000000;">
        {#if find_help_text_if_exists(helptexts, "management_reporting_report")}
          {@html find_help_text_if_exists(helptexts, "management_reporting_report")}
        {:else}
          <p>
            The Market progress report provides you with information on the <strong>lead generation</strong> and the
            <strong>development of the number of boluses</strong> in the selected markets during the reporting timeframe.
          </p>
          <p>
            Run the report for new leads by selecting <em>&ldquo;New leads&rdquo;</em>. <br />By selecting
            <em>&ldquo;Active boluses&rdquo;</em>, the report will show you how the number of boluses evolved from month to month.
          </p>
          <p>
            <span style="color: #808080;"
              >Please note: Leads from the <strong>sales source category "data import"</strong> are only counted as &rdquo;new lead" if an opportunity
              is created based on the lead. In this case, the lead creation date is the same as the opportunity creation date.</span
            >
          </p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: management_reporting_report</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div>
    <div />
  </div>
  <div class="card-body">
    <div class="row green-border" style="margin:auto; margin-bottom: 30px; padding: 10px; background-color: #fbfcfb;">
      <div class="col-2" style="font-size:10px;">Show report for:</div>
      <div class="col-10" style="font-size:10px;">
        <div class="row">
          <label style="font-weight: 600;"
            ><input type="radio" bind:group={lead_or_boli} id="selcec_leads_boli12" name="leads2" value={3} />&nbsp;New Leads</label
          ><br />
        </div>
        <div class="row">
          <label style="font-weight: 600;"
            ><input type="radio" bind:group={lead_or_boli} id="selcec_leads_boli22" name="boli2" value={4} />&nbsp;Active Boluses</label
          ><br />
        </div>
      </div>
    </div>
    <table style="width:100%;">
      <colgroup>
        <col span="1" style="width: {months.length > 12 ? 5 : 10}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />

        {#each months as monats_label, index}
          <col span="1" style="width: {get_width_percentage(months)}%;" />
        {/each}

        <col span="1" style="width: {get_width_percentage(months)}%;" />
      </colgroup>
      <tr>
        <th />
        <th style="text-align: center">
          <div
            style="height: 35px;
            margin-left: 5px; margin-right: 5px; font-size:9px;
                background-color: #d7e2dc; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px;"
          >
            <span>Median {marketing_start_date.getFullYear() - 1} <br /> p.m.</span>
          </div>
        </th>

        {#each months as monats_label, index}
          <th style="text-align: center">
            <div
              nowrap
              style="height: 35px; background-color: #f2f2f2; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px; margin-left:5px; margin-right:5px;"
            >
              <span>{month_format(monats_label)}</span>
            </div>
          </th>
        {/each}

        <th style="text-align: center">
          <div
            style="height: 35px;
            margin-left: 12px; margin-right: 12px;
                background-color: #d7e2dc; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px;"
          >
            <span>Total</span>
          </div>
        </th>
      </tr>

      {#each laender_dict as land_eintrag, country_index}
        <!-- leere Zeile -->
        {#if land_eintrag["checked"]}
          <tr style="border-bottom: 0.5px solid #d9d9d9;">
            {#each months as monats_label, index}
              {#if index == 0}
                <td style="border-bottom: 0.5pt solid #d9d9d9;">&nbsp;</td>
              {:else}
                <td>&nbsp;</td>
              {/if}
            {/each}
          </tr>

          <tr style="">
            <td style="padding-top:0px; width:200px;">
              <div
                style="white-space: nowrap; width: 53px; background-color: #d7e2dc; padding-left:10px;padding-right:10px;padding-top:0px;padding-bottom:5px;"
              >
                {land_eintrag["short"]}
              </div>
            </td>
            {#each months as monats_label, index}
              {#if index != 0}
                <td />
              {/if}
            {/each}
          </tr>

          <tr style="vertical-align: bottom; ">
            <td style="height: 100px;">
              <PartialCircleElementTorte
                second_position={true}
                winkel_innen={adressable_market_size_charts_dict[land_eintrag["short"]]["AMS_percentage"]}
                winkel_outer={adressable_market_size_charts_dict[land_eintrag["short"]]["AMT_percentage"]}
                number={15500 + country_index}
                radius={land_eintrag["radius"]}
              />
            </td>
            {#if months.length > 0}
              <td style="vertical-align: bottom; border-bottom: 0.5pt solid #d9d9d9;">
                <NewLeadsBalkenElement
                  vorgaenger_box_color={"#d9d9d9"}
                  max_value={max_of_dict(table_data_dict[land_eintrag["long"]])}
                  value={table_date_basis[land_eintrag["long"]]}
                  background_color_bottom={"#d9d9d9"}
                />
              </td>
            {/if}
            {#each months as monats_label, index}
              <td style="vertical-align: bottom; border-bottom: 0.5pt solid #d9d9d9;">
                <NewLeadsBalkenElement
                  max_value={max_of_dict(table_data_dict[land_eintrag["long"]])}
                  value={table_data_dict[land_eintrag["long"]][monats_label]}
                />
              </td>
            {/each}

            <td class="hoverclass" style="vertical-align: bottom; border-bottom: 0.5px solid #d9d9d9;">
              {#if table_data_dict[land_eintrag["long"]]}
                <NewLeadsBalkenElement
                  total_text={"New"}
                  is_total={true}
                  max_value={get_vorgaenger(table_data_dict[land_eintrag["long"]], months.length, table_date_basis[land_eintrag["long"]])}
                  value={dict_to_sum(table_data_dict[land_eintrag["long"]])}
                />
              {/if}
              <div class="info-box-auf-hoehe">
                <p><strong>New leads</strong> &hellip; Total number of leads created during reporting timeframe.</p>
                <p>
                  Please note: Leads from the <strong>sales source category "data import"</strong> are only counted as &rdquo;new lead" if an
                  opportunity is created based on the lead. In this case, the lead creation date is the same as the opportunity creation date.
                </p>
              </div>
            </td>
          </tr>

          <tr>
            <td>&nbsp;</td>
            <td style="font-size: 8px; text-align:center;">Basis</td>
            {#each months as monats_label, index}
              <td style="font-size: 8px; text-align:center;">{month_format(monats_label)}</td>
            {/each}

            <td style="font-size: 8px;text-align:center; padding-right: 40px;">Total</td>
          </tr>
        {/if}
      {/each}
    </table>
  </div>
</div>

<style>
  .green-border {
    /*background-color: #fbfcfc;*/
    border-width: 0.25px;
    border-style: solid;
    border-color: #afc5b9 !important;
  }

  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: auto;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: var(--y);
    left: var(--x);
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 50px;
    right: 50px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
